import React from "react";
import cx from "classnames";
var classPrefix = "tc-score-star";
var Star = function Star(props) {
  var progress = props.progress,
    className = props.className,
    color = props.color,
    size = props.size,
    style = props.style,
    grounding = props.grounding;
  var strId = Math.random().toString(36).slice(-8);
  var baseProps = {
    className: cx(classPrefix, className, "".concat(classPrefix, "-").concat(size)),
    style: style
  };
  return /*#__PURE__*/React.createElement("svg", Object.assign({}, baseProps, {
    viewBox: '0 0 28 28',
    version: '1.1'
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: strId,
    x1: '0%',
    y1: '0%',
    x2: "".concat(progress, "%"),
    y2: '0%'
  }, /*#__PURE__*/React.createElement("stop", {
    offset: '0%',
    style: {
      stopColor: color,
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: '100%',
    style: {
      stopColor: color,
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: '100%',
    style: {
      stopColor: grounding,
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: 'none',
    strokeWidth: '1',
    fill: "".concat(progress === 0 ? grounding : "url(#".concat(strId, ")")),
    fillRule: 'evenodd'
  }, /*#__PURE__*/React.createElement("g", {
    transform: 'translate(-478.000000, -1015.000000)'
  }, /*#__PURE__*/React.createElement("g", {
    transform: 'translate(29.000000, 954.000000)'
  }, /*#__PURE__*/React.createElement("g", {
    transform: 'translate(144.000000, 0.000000)'
  }, /*#__PURE__*/React.createElement("g", {
    transform: 'translate(0.000000, 56.000000)'
  }, /*#__PURE__*/React.createElement("g", {
    transform: 'translate(120.000000, 5.000000)'
  }, /*#__PURE__*/React.createElement("polygon", {
    points: '199 23.4284319 190.183221 27.1352549 190.984085 17.6045287 184.734152 10.3647451 194.045892 8.18125534 199 0 203.954108 8.18125534 213.265848 10.3647451 207.015915 17.6045287 207.816779 27.1352549'
  }))))))));
};
Star.defaultProps = {
  size: "middle",
  color: "#FFC069",
  progress: 0
};
export default Star;